
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

type FeedbackSectionProps = {
  title: string;
  content?: string | null;
  titleColor?: string;
  bgColor?: string;
  clickable?: boolean;
  onClick?: () => void;
};

export const FeedbackSection = ({ 
  title, 
  content, 
  titleColor = "text-gray-800",
  bgColor = "bg-gray-50",
  clickable = false,
  onClick
}: FeedbackSectionProps) => {
  // Vérification complète pour éviter d'afficher des sections vides
  const hasContent = content !== null && content !== undefined && content.trim() !== '';
  
  if (!hasContent) return null;
  
  const cardClasses = clickable 
    ? "shadow-sm overflow-hidden mb-4 hover:shadow-md transition-shadow cursor-pointer" 
    : "shadow-sm overflow-hidden mb-4";
  
  return (
    <Card 
      className={cardClasses} 
      onClick={clickable && onClick ? onClick : undefined}
    >
      <CardHeader className={`pb-2 ${bgColor} border-b`}>
        <CardTitle className={`text-lg ${titleColor}`}>
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <p className="whitespace-pre-wrap text-gray-700">
          {content}
        </p>
      </CardContent>
    </Card>
  );
};
